export const useCasesQueryParamKey = 'useCaseGroups';
export function getUseCasesByPage(page) {
  switch (page) {
    case 'smart-crm':
    case 'sales':
    case 'data':
    case 'commerce':
    case 'crm':
      return ['SALES'];
    case 'service':
      return ['SERVICE'];
    case 'suite':
      return ['MARKETING', 'SALES', 'SERVICE'];
    case 'marketing':
    case 'content':
    case 'marketing-plus':
    case 'bundle':
    default:
      return ['MARKETING'];
  }
}